import { downloadTextFile } from './download';

/** @deprecated */
export async function registrosToCsv<Registro>(
    registros: Registro[],
    fileName: string,
    keys?: string[],
    extra?: string[],
): Promise<void> {
    let blobArray = convertObjectArrayToCSV(registros, keys);

    if (extra) {
        blobArray = blobArray.concat(extra);
    }

    await downloadTextFile(blobArray, `${fileName}.csv`);
}

/** @deprecated */
export type CsvData = {
    fileName: string;
    tableNames: string[];
    tables: unknown[][] | null;
};

/** @deprecated */
export async function multiRegistrosToCsv(csvData: CsvData, keys?: string[]): Promise<void> {
    if (!csvData?.tables) {
        return;
    }

    let blobArray: string[] = [];

    for (const [idx, table] of csvData.tables.entries()) {
        blobArray.push(csvData.tableNames[idx] || '');
        blobArray.push('\n');
        blobArray = blobArray.concat(convertObjectArrayToCSV(table, keys));
    }

    await downloadTextFile(blobArray, csvData.fileName);
}

/** @deprecated */
function convertObjectArrayToCSV<Registro>(registros: Registro[], keys?: string[]): string[] {
    if (registros.length === 0) {
        return [''];
    }

    // gerando lista de chaves de Registro
    let chaves: string[];

    // caso uma lista de chaves tenha sido fornecida
    if (keys) {
        chaves = keys;
    } else {
        const obj = {};
        const firstRegistro = registros[0] as Registro;
        Object.assign(obj, firstRegistro);
        chaves = keys || Object.keys(obj);
    }

    const blobArray: string[] = [];

    // linha titulo do csv
    blobArray.push(chaves.map((chave) => chave.toUpperCase()).join(';'));

    // cada registro da array vira uma linha
    for (const registro of registros) {
        const tempArr: string[] = [];

        for (const chave of chaves) {
            let addItem = registro[chave];

            if (typeof registro[chave] === 'number') {
                addItem = `"${registro[chave].toLocaleString('pt-BR')}"`;
            } else if (addItem && typeof addItem === 'string' && addItem.includes(',')) {
                addItem = `"${registro[chave]}"`;
            }

            if (typeof addItem === 'object') {
                addItem = JSON.stringify(addItem);
            }

            tempArr.push(addItem);
        }

        blobArray.push(tempArr.join(';'));
    }

    return blobArray;
}

export async function saveArrayToCsv<T extends object>(
    fileName: string,
    registros: T[],
): Promise<void> {
    const rows = arrayToCsv(registros);
    await downloadTextFile(rows, `${fileName}.csv`);
}

export function arrayToCsv<T extends object>(registros: T[]): string[] {
    const rows: string[] = [];
    const first = registros[0];

    if (registros.length === 0 || !first) {
        return rows;
    }

    const firstRecord = first as Record<string, unknown>;
    const keys = Object.keys(firstRecord);
    const arrayKey = keys.find((key) => Array.isArray(firstRecord[key]));

    if (!arrayKey) {
        rows.push(keys.join(';'));

        for (const registro of registros) {
            const record = registro as Record<string, unknown>;
            rows.push(keys.map((key) => csvValue(record[key])).join(';'));
        }

        return rows;
    }

    const parentKeys = keys.filter((key) => key !== arrayKey);
    const firstNestedArray = firstRecord[arrayKey] as Record<string, unknown>[];
    const nestedKeys = firstNestedArray?.[0] ? Object.keys(firstNestedArray[0]) : [];

    rows.push(
        [...parentKeys, ...nestedKeys.map((key) => `${arrayKey}_${key}`)]
            .map((key) => csvValue(key))
            .join(';'),
    );

    for (const registro of registros) {
        const record = registro as Record<string, unknown>;
        const parentValues = parentKeys.map((key) => csvValue(record[key]));
        const nestedArray = Array.isArray(record[arrayKey])
            ? (record[arrayKey] as Record<string, unknown>[])
            : [];

        if (nestedArray.length === 0) {
            rows.push([...parentValues, ...nestedKeys.map(() => '')].join(';'));
            continue;
        }

        for (const [index, nested] of nestedArray.entries()) {
            const visibleParentValues = index === 0 ? parentValues : parentKeys.map(() => '-');
            const nestedValues = nestedKeys.map((key) => csvValue(nested[key]));
            rows.push([...visibleParentValues, ...nestedValues].join(';'));
        }
    }

    return rows;
}

function csvValue(value: unknown): string {
    if (typeof value === 'number') {
        return value.toString().replace('.', ',');
    }

    if (typeof value === 'string') {
        return escapeCsvString(value);
    }

    if (typeof value === 'boolean') {
        return value ? 'true' : 'false';
    }

    return '';
}

function escapeCsvString(value: string): string {
    if (!/[;"\n\r]/.test(value)) {
        return value;
    }

    return `"${value.replaceAll('"', '""')}"`;
}
